import { pascalCase } from 'pascal-case';

const generateIconVariationTitle = (iconTitle: string, { title, fileName }: ApiIconVariationResponse): string => {
  if (title && !title.includes('-var-')) return title;
  if (fileName.includes('-var-')) {
    const lioVar = fileName.lastIndexOf('-var-') + 5;
    const ioDot = fileName.indexOf('.', lioVar);
    const filenameVars = fileName.substring(lioVar, ioDot).split('-');
    const titleParts = filenameVars.map(fv => {
      if (['rgb', 'cmyk'].includes(fv)) {
        return fv.toUpperCase();
      }
      return pascalCase(fv);
    });
    return `${iconTitle} ${titleParts.join(' ')}`;
  }
  return fileName;
};

const sanitizeIconVariation =
  (title: string) =>
  (dto: ApiIconVariationResponse): IconVariation => ({
    id: dto.id,
    title: generateIconVariationTitle(title, dto),
    downloadUrl: dto.downloadUrl,
    extension: dto.extension.trim().toUpperCase(),
    fileName: dto.fileName,
  });

export default sanitizeIconVariation;
